import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Comment } from '../models/comment';
import { deleteCommentEndpoint } from './const';

export const deleteComment = (comment: Comment) => {
    comment.isDeleted = true;
    return getHttpClient().post({ url: deleteCommentEndpoint, data: JSON.stringify(comment) });
};
